import { ContentBlockTypes } from 'api/landingPageTheme'
import HelpCenterLink from 'components/HelpCenterLink'
import React from 'react'
import { links } from './helpers'

type Props = {
  type: ContentBlockTypes
}

const HelpLinkSection = ({ type }: Props) => {
  const { description, url } = links[type] || {}
  if (!description || !url) return null

  return <HelpCenterLink description={description} helpUrl={url} />
}

export default HelpLinkSection
